module.exports = __webpack_public_path__ + "9261c5a728ec358a19b9a87034fc7f9c.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/Vani.png
// module id = 577
// module chunks = 30